// staging
export const BASE_URL_STAGING = "http://bpapre-sg1-app-01.it.tpgtelecom.com.sg:3002/"
// export const BASE_URL = "https://bpapre.it.tpgtelecom.com.sg/rego/"

//prod
export const BASE_URL = "https://registration.simba.sg/rego/"

//prod singpass
export const BASE_URL_SI = "https://registration.simba.sg/rego/"
// export const BASE_URL_SI = "https://registration.simba.sg:8443/"

export const oneMapBaseUrl = "https://developers.onemap.sg"
export const oneMapSearchEndpoint = "/commonapi/search"
export const SECRET_KEY = "6Lfx3ssbAAAAAEK-JqkrOqqQ0vv4j2E9Wyu9Zwmd"